'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateFromHTML = require('./stateFromHTML');

Object.defineProperty(exports, 'stateFromHTML', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateFromHTML).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-import-html/lib/main.js
// module id = 454
// module chunks = 1 2